// Zentrale SEO-Schema-Definitionen für die gesamte Website

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Praxis Versichert",
  url: "https://praxis-versichert.de",
  logo: "https://praxis-versichert.de/logo.png",
  description: "Spezialisierte Cyberversicherung für Arztpraxen, Zahnarztpraxen, Facharztpraxen, MVZ und Kliniken in Deutschland",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+49-163-6389945",
    contactType: "customer service",
    email: "info@praxis-versichert.de",
    availableLanguage: "de"
  },
  address: {
    "@type": "PostalAddress",
    addressCountry: "DE"
  },
  sameAs: [
    "https://praxis-versichert.de"
  ]
});

export const getWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Praxis Versichert",
  url: "https://praxis-versichert.de",
  description: "Cyberversicherung für medizinische Praxen in Deutschland",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://praxis-versichert.de/cyberversicherung?search={search_term_string}",
    "query-input": "required name=search_term_string"
  }
});

export const getBreadcrumbSchema = (items: Array<{ name: string; url?: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    ...(item.url && { item: item.url })
  }))
});

export const getLocalBusinessSchema = (city: string) => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: `Praxis Versichert - Cyberversicherung ${city}`,
  url: `https://praxis-versichert.de/cyberversicherung/${city.toLowerCase()}`,
  description: `Spezialisierte Cyberversicherung für Arztpraxen in ${city}`,
  address: {
    "@type": "PostalAddress",
    addressLocality: city,
    addressCountry: "DE"
  },
  areaServed: {
    "@type": "City",
    name: city
  },
  priceRange: "$$"
});

export const getServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Cyberversicherung für Arztpraxen",
  provider: {
    "@type": "Organization",
    name: "Praxis Versichert"
  },
  areaServed: "Deutschland",
  description: "Umfassende Cyberversicherung speziell für medizinische Einrichtungen"
});

export const getFAQPageSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(faq => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer
    }
  }))
});

export const getInsuranceProductSchema = (config: {
  name: string;
  description: string;
  url: string;
  brand: string;
  rating?: {
    value: number;
    count: number;
  };
  priceRange?: string;
  image?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: config.name,
  description: config.description,
  url: config.url,
  brand: {
    "@type": "Brand",
    name: config.brand
  },
  image: config.image || "https://praxis-versichert.de/logo.png",
  ...(config.rating && {
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: config.rating.value,
      reviewCount: config.rating.count,
      bestRating: "5",
      worstRating: "1"
    }
  }),
  ...(config.priceRange && {
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "EUR",
      lowPrice: config.priceRange.split('-')[0],
      highPrice: config.priceRange.split('-')[1] || config.priceRange.split('-')[0],
      availability: "https://schema.org/InStock"
    }
  }),
  category: "Cyberversicherung"
});
